import { render, staticRenderFns } from "./matterinfo.vue?vue&type=template&id=4d0d3c5b&scoped=true&"
import script from "./matterinfo.vue?vue&type=script&lang=js&"
export * from "./matterinfo.vue?vue&type=script&lang=js&"
import style0 from "./matterinfo.vue?vue&type=style&index=0&id=4d0d3c5b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0d3c5b",
  null
  
)

export default component.exports